export const icedOutIntroLyrics = [
  { text: "Taps Microphone", start: 0, end: 1.5 },
  { text: "Ahem", start: 1.5, end: 2.5 },
  { text: "Ladies and gentleman", start: 2.5, end: 4 },
  { text: "Welcome", start: 4, end: 5.5 },
  { text: "To the 2026", start: 5.5, end: 7.3 },
  { text: "Annual", start: 7.3, end: 8.1 },
  { text: "Reel-a-thon", start: 8.1, end: 9.5 },
  { text: "You will be given 30 days", start: 9.5, end: 11.5 },
  { text: "To reach five million people", start: 11.5, end: 14.3 },
  { text: "Laughs", start: 14.3, end: 15.1 },
  { text: "Now", start: 15.1, end: 16 },
  { text: "There can only be two vanquishers", start: 16, end: 18.5 },
  { text: "One man", start: 18.5, end: 19.7 },
  { text: "And one woman", start: 19.7, end: 21.4  },
  { text: "May fortune", start: 21.4, end: 22.8 },
  { text: "Smile", start: 22.8, end: 24.2},
  { text: "Upon you", start: 24.2, end: 25 },
  { text: "Attention", start: 25, end: 25.8 },
  { text: "Well my life I lay down on the line", start: 25.8, end: 28.6 },
  { text: "On the line", start: 28.6, end: 29.5 },
  { text: "Well my life I lay down on the line", start: 29.5, end: 32.2 },
  { text: "On the line", start: 32.2, end: 33.2 },
  { text: "Ain't no other console like my trusty landline", start: 33.2, end: 36.7 },
  { text: "Ain't no other console like my trusty landline", start: 36.7, end: 40.6 },
  { text: "Every chamber of my mind she controls", start: 40.6, end: 43.4 },
  { text: "She controls", start: 43.4, end: 44.4 },
  { text: "Every chamber of my mind she controls", start: 44.4, end: 47.2 },
  { text: "She controls", start: 47.2, end: 48.2 },
  { text: "I can't survive less she everywhere I go", start: 48.2, end: 51.9 },
  { text: "I can't survive less she everywhere I go", start: 51.9, end: 55.8 },
  { text: "Soldiers", start: 55.8, end: 57 },
  { text: "About face", start: 57, end: 59.3 },
  { text: "Boot stomps", start: 59.3, end: 61.6 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start: number, readonly end: number }>;
